module.exports = __webpack_public_path__ + "static/media/change.9a33abe1.gif";


//////////////////
// WEBPACK FOOTER
// ./src/res/img/help/change.gif
// module id = 425
// module chunks = 0